import { useStoreActions, useStoreState } from 'easy-peasy'
import { useAsync } from 'react-use'
import _ from 'lodash'

import Select from 'components/Select'

import { useTranslate } from 'hooks/translate'

import Styled from './styled'

export default function FilterProfileSelect({
  disabled = false,
  value = null,
  onChange = () => null,
}) {
  const { t } = useTranslate()

  const filterProfiles = useStoreState((state) => state.filter.profiles)

  const getFilterProfiles = useStoreActions((actions) => actions.filter.getProfiles)

  const options = _.map(filterProfiles, (filterProfile) => {
    return {
      label: filterProfile?.name,
      value: filterProfile?.id,
    }
  })

  useAsync(async () => {
    getFilterProfiles()
  }, [])

  const selectProps = {
    defaultValue: value,
    disabled,
    options,
    placeholder: t('Profile'),
    onChange,
  }

  return (
    <Styled className="filter-profile-select-component">
      <Select {...selectProps} />
    </Styled>
  )
}
